import React from 'react';
import '../../styles/LegalPages.css';

const LegalNotice = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <div className="legal-content-header">
                    <h1>Legal Notice</h1>
                    <p className="last-updated">Information according to applicable law</p>
                </div>

                <div className="legal-content glass">
                    <section className="legal-section">
                        <h2>Company Information</h2>
                        <div className="contact-info-legal">
                            <p>
                                <strong>Ferritico AB</strong><br/>
                                c/o Openlab<br/>
                                Valhallavägen 79<br/>
                                114 28 Stockholm<br/>
                                Sweden
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>Contact</h2>
                        <div className="contact-info-legal">
                            <p>
                                {/* Temporarily hidden — restore by removing this comment wrapper
                                <strong>Phone:</strong> +46 (0)8 121 530 03<br/>
                                */}
                                <strong>Email:</strong> <a href="mailto:contact@ferritico.com">contact@ferritico.com</a><br/>
                                <strong>Website:</strong> <a href="https://ferritico.com">www.ferritico.com</a>
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>Registration Details</h2>
                        <div className="contact-info-legal">
                            <p>
                                <strong>Company Registration Number:</strong> 559081-6020<br/>
                                <strong>Registry Court:</strong> Bolagsverket (Swedish Companies Registration Office)<br/>
                                <strong>Registered Office:</strong> Stockholm, Sweden
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>Management</h2>
                        <div className="contact-info-legal">
                            <p>
                                <strong>CEO:</strong> Dr. Viswanadh Arigela
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>VAT Information</h2>
                        <div className="contact-info-legal">
                            <p>
                                <strong>VAT ID:</strong> SE5590816020<br/>
                                <strong>Swedish VAT Number:</strong> 559081-6020
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>Responsible for Content</h2>
                        <div className="contact-info-legal">
                            <p>
                                Dr. Viswanadh Arigela<br/>
                                Ferritico AB<br/>
                                c/o Openlab<br/>
                                Valhallavägen 79<br/>
                                114 28 Stockholm, Sweden
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>Disclaimer</h2>
                        
                        <h3>Liability for Content</h3>
                        <p>
                            As a service provider, we are responsible for our own content on these pages 
                            according to applicable laws. However, as a service provider, we are not 
                            obligated to monitor transmitted or stored third-party information or to 
                            investigate circumstances that indicate illegal activity.
                        </p>
                        <p>
                            Obligations to remove or block the use of information according to general 
                            laws remain unaffected. However, liability in this regard is only possible 
                            from the time of knowledge of a specific legal violation. Upon becoming 
                            aware of corresponding legal violations, we will remove this content immediately.
                        </p>

                        <h3>Liability for Links</h3>
                        <p>
                            Our offer contains links to external third-party websites over whose content 
                            we have no influence. Therefore, we cannot assume any liability for this 
                            external content. The respective provider or operator of the pages is always 
                            responsible for the content of the linked pages. The linked pages were 
                            checked for possible legal violations at the time of linking. 
                            Illegal content was not recognizable at the time of linking.
                        </p>
                        <p>
                            However, permanent monitoring of the content of linked pages is not reasonable 
                            without concrete evidence of a legal violation. Upon becoming aware of legal 
                            violations, we will remove such links immediately.
                        </p>

                        <h3>Copyright</h3>
                        <p>
                            The content and works created by the site operators on these pages are 
                            subject to Swedish and international copyright law. The reproduction, 
                            editing, distribution, and any kind of use outside the limits of copyright 
                            law require the written consent of the respective author or creator. 
                            Downloads and copies of this page are only permitted for private, 
                            non-commercial use.
                        </p>
                        <p>
                            Insofar as the content on this site was not created by the operator, 
                            the copyrights of third parties are respected. In particular, third-party 
                            content is identified as such. Should you nevertheless become aware of 
                            a copyright infringement, please inform us accordingly. Upon becoming 
                            aware of legal violations, we will remove such content immediately.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Dispute Resolution</h2>
                        <p>
                            The European Commission provides a platform for online dispute resolution (ODR): 
                            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                            https://ec.europa.eu/consumers/odr/</a>. 
                            Our email address can be found in the legal notice above.
                        </p>
                        <p>
                            We are not willing or obliged to participate in dispute resolution proceedings 
                            before a consumer arbitration board.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Applicable Law and Jurisdiction</h2>
                        <p>
                            All legal relationships between the parties are governed by Swedish law, 
                            excluding the laws on the international purchase of movable goods. 
                            For consumers, this choice of law only applies insofar as the protection 
                            granted is not withdrawn by mandatory provisions of the law of the state 
                            in which the consumer has their habitual residence.
                        </p>
                        <p>
                            The exclusive place of jurisdiction for all disputes arising from this 
                            contract is Stockholm, Sweden, provided the customer is a merchant, 
                            a legal entity under public law, or a special fund under public law.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Professional Liability Insurance</h2>
                        <p>
                            Ferritico AB maintains professional liability insurance appropriate to our 
                            business activities. Details about our insurance coverage are available 
                            upon request.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Industry Standards and Compliance</h2>
                        <p>
                            Our services comply with applicable industry standards and regulations, 
                            including but not limited to:
                        </p>
                        <ul>
                            <li>European data protection regulations (GDPR)</li>
                            <li>Swedish business regulations</li>
                            <li>International steel industry standards</li>
                            <li>Environmental and sustainability guidelines</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default LegalNotice;
